import { useEffect, useState } from "react";
import { AlertTriangle, Download } from "lucide-react";

const explain = (code, probe) => {
  if (probe && probe.status >= 400) return `The server could not deliver the video (HTTP ${probe.status}). Please try again or re-upload the episode.`;
  if (code === 2) return "Network error while loading the video. Check your connection and reload.";
  if (probe?.type && !/^video\/(mp4|webm)/.test(probe.type)) return `This file is served as "${probe.type}", which browsers cannot play. Convert it to MP4 (H.264 video + AAC audio) and upload again.`;
  return "Your browser cannot decode this file. MKV, HEVC/H.265 or 10-bit anime rips do not play in browsers — convert to MP4 (H.264 + AAC) and upload again.";
};

// Shown over the player when the <video> element fires an error; probes the URL to tell server errors from codec problems.
export const PlaybackError = ({ src, code }) => {
  const [probe, setProbe] = useState(null);
  useEffect(() => {
    fetch(src, { headers: { Range: "bytes=0-1" } })
      .then((r) => setProbe({ status: r.status, type: r.headers.get("content-type") || "" }))
      .catch(() => setProbe({ status: 0, type: "" }));
  }, [src]);
  return (
    <div data-testid="playback-error" className="absolute inset-0 bg-black/85 flex flex-col items-center justify-center text-center px-8 gap-4">
      <AlertTriangle size={30} className="text-[#FF2A55]" />
      <p className="font-display font-semibold text-lg">This episode can't be played</p>
      <p data-testid="playback-error-reason" className="text-[#94A3B8] text-sm max-w-xl leading-relaxed">{explain(code, probe)}</p>
      {probe && <p className="font-mono text-[0.65rem] text-[#64748B]">code {code ?? "?"} · http {probe.status || "n/a"} · {probe.type || "unknown type"}</p>}
      <a data-testid="playback-download-link" href={src} download className="kp-btn kp-btn-ghost text-xs mt-2"><Download size={14} /> Download file instead</a>
    </div>
  );
};
